import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class DevErrorHandlerService implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: unknown): void {
    const err = error instanceof Error ? error : new Error(String(error));
    console.error(err);

    setTimeout(() => this.showToast(err));
  }

  private showToast(err: Error): void {
    try {
      const title = err.name && err.name !== 'Error' ? err.name : 'Unhandled Error';
      this.injector.get(ToastrService).error(err.message || 'An unexpected error occurred', title, {
        timeOut: 0,
        extendedTimeOut: 0,
        tapToDismiss: true,
      });
    } catch {
      // Toastr not ready yet during early bootstrap — already logged above.
    }
  }
}
